<template>
  <div>
    <div v-for="info in this.footerInfo" :key="info.id">
      <FooterInfo :footerInfo="info" infoType="agb" />
    </div>
  </div>
</template>

<script>
  import FooterInfo from "@/views/components/FooterInfo";
  import {mapActions} from 'vuex'

  export default {
    components: {
      FooterInfo
    },
    data() {
      return {
        footerInfo: [],
      }
    },
    methods: {
      ...mapActions(['fetchFooterInfo']),
    },
    mounted() {
      this.fetchFooterInfo().then( _ => {
        this.footerInfo = this.$store.getters.getFooterInfos
      })
    },
  }
</script>

<style scoped>

</style>
